import urls from '../../urls';
import { redirectRoute } from '../helpers';
import SmartcardStore from '../../stores/SmartcardStore';
import UserStore from '../../stores/UserStore';
import { AccountPages, PointStages, AccountPagesForceLoginInsteadOfRedirect, GlobalModals } from '../../constants/AppConstants';
import CustomerActions from '../../actions/CustomerActions';
import ModalActions from '../../../src/actions/ModalActions';

module.exports = {
    path: '/account',

    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/account/Layout').default);
        }, 'account-layout');
    },

    indexRoute: redirectRoute(null, AccountPages.ACCOUNT_DETAILS),

    getChildRoutes(location, cb) {
        require.ensure([], (require) => {
            cb(null, [
                require('./Details'),
                require('./Addresses'),
                require('./PreferenceCentre'),
                require('./PhotocardsRailcards'),
                require('./Payment'),
                require('./Evouchers'),
                require('./PurchaseHistory'),
                require('./OrderDetails'),
                require('./RefundDetails'),
                require('./AmendDetails'),
                require('./SmartcardApply'),
                require('./SmartcardLink'),
                require('./Smartcard/Transfer'),
                require('./Smartcard'),
                require('./Etickets'),
                require('./STickets'),
                require('./DisruptionAlerts'),
                require('./LinkOrder'),
                require('./SmartCarnet/SmartCarnetAccountRoute'),
                require('./FlexiSeason'),
                require('./AutoDelayRepay'),
                require('./OneClickDelayRepay'),
                require('./passengerAssist/BookPassengerAssist'),
                require('./passengerAssist/ViewBookedAssistance'),
                require('./passengerAssist/AccessibilityProfile'),
            ].filter((x) => !!x));
        }, 'account-routes');
    },

    async onEnter (nextState, replace, callback) {
        const user = UserStore.getCurrent();
        const skipRedirect = AccountPagesForceLoginInsteadOfRedirect.includes(urls.resolve(nextState.location.pathname).name);
        if (!skipRedirect && (!user || !user.isLoggedIn())) {
            replace(urls.location(PointStages.SEARCH));
            ModalActions.open(GlobalModals.LOGIN, {initialPath: nextState.location.pathname});
        }

        //Load smartcards first, as the account pages expect them to be loaded
        if (!SmartcardStore.getCurrent()) {
            const smartcard = await CustomerActions.getSmartcard(user);
            if (smartcard) {
                await CustomerActions.getAllSmartcards(user);
            }
        }
        callback();
    }
};



// WEBPACK FOOTER //
// ./src/routes/Account/index.js